/**
 * Buy It Now functionality
 * Adds product to cart and redirects to checkout
 */

class BuyItNow {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      const button = e.target.closest('[data-buy-it-now]');
      if (!button) return;

      e.preventDefault();
      this.handleBuyItNow(button);
    });
  }

  async handleBuyItNow(button) {
    // Prevent multiple clicks
    if (button.disabled || button.classList.contains('is-loading')) {
      return;
    }

    const formId = button.dataset.formId;
    const form = document.getElementById(formId);

    if (!form) {
      console.error('Form not found:', formId);
      return;
    }

    // Get form data
    const formData = new FormData(form);
    const variant_id = formData.get('id');
    const quantity = formData.get('quantity') || 1;

    // Collect properties
    const properties = {};
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('properties[') && value) {
        const propKey = key.match(/properties\[(.*?)\]/)[1];
        properties[propKey] = value;
      }
    }

    // Show loading state
    button.disabled = true;
    button.classList.add('is-loading');
    const buttonContent = button.querySelector('.button__content');
    const originalText = buttonContent ? buttonContent.textContent : button.textContent;
    
    if (buttonContent) {
      buttonContent.textContent = 'Adding...';
    } else {
      button.textContent = 'Adding...';
    }

    try {
      // Add to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variant_id,
          quantity: parseInt(quantity),
          properties: Object.keys(properties).length > 0 ? properties : undefined
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();
      
      // Trigger cart update event (if your theme uses it)
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          cart: data
        }
      }));

      // Redirect to checkout
      window.location.href = '/checkout';

    } catch (error) {
      console.error('Buy it now error:', error);
      
      // Show error message
      const errorText = 'Error - Try again';
      if (buttonContent) {
        buttonContent.textContent = errorText;
      } else {
        button.textContent = errorText;
      }
      button.classList.add('button--error');
      
      // Reset button after 2 seconds
      setTimeout(() => {
        button.disabled = false;
        button.classList.remove('is-loading', 'button--error');
        if (buttonContent) {
          buttonContent.textContent = originalText;
        } else {
          button.textContent = originalText;
        }
      }, 2000);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BuyItNow();
  });
} else {
  new BuyItNow();
}

